/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {ReactNode, createRef, useCallback, useEffect, useRef, useState} from 'react'
import SharedData from '../../common/SharedData'
import Loader from '../../common/Loader'
import NormalMessage from '../../common/NormalMessage'
import {getDuplicateBarcodes} from '../add-bulk/core/_requests'
import {IDuplicateBarcodeModel} from '../cors/_models'
import DuplicateBarcodeTable from './DuplicateBarcodeTable'
import { useIntl } from 'react-intl'
import DeleteRequestBtn from '../add-special/components/DeleteRequestBtn'

interface IProps {
  
}
export  interface IDuplicateTableRef {
  submitTable(): void;
}
const DuplicateBarcodeDetails: React.FC<IProps> = ({}) => {
  const {formatMessage} = useIntl();
  const {currentUser, language} = SharedData()
  const [duplicateList, setDuplicateList] = useState<IDuplicateBarcodeModel[]>([])
  const tableRef = createRef<IDuplicateTableRef>();
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const getDate = async () => {
      setIsLoading(true)
      const {data} = await getDuplicateBarcodes(currentUser?.token, language)
      if (data) {
        setDuplicateList(data.requests)
      }
      setIsLoading(false)
    }
    getDate()
  }, [])

  const resultsData = (): ReactNode => {
    if (isLoading) {
      return <Loader />
    }
    if (duplicateList.length > 0) {
      return (
        <>
          <div className='py-3'>
            <DuplicateBarcodeTable currentUser={currentUser} ref={tableRef} products={duplicateList} />
          </div>
        </>
      )
    }
    return <NormalMessage msg={formatMessage({ id: "no_data" })} />
  }

  return (
    <>
      <div className='hib-note-amber mb-5' role='note'>
        <i className='fas fa-circle-exclamation' aria-hidden='true' />
        <span>{formatMessage({ id: "duplicated_prods_hint" })}</span>
      </div>

      <div className={`card`}>
        <div className='card-body'>{resultsData()}</div>
      </div>

      <div className='hib-actionbar'>
        <DeleteRequestBtn isProductBulk={true} />
        <button onClick={()=>tableRef.current?.submitTable()} className='btn btn-dark'>{formatMessage({ id: "send_req" })}</button>
      </div>
    </>
  )
}

export default DuplicateBarcodeDetails
